module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACHSURBVHgBrdGhFcJAEITh2TkKOCSOEpJOsEgcNpVgcUhsSqADKIEOSAF3GXYlkuR+sfJ7u28N3ud+3pekm0GdZBl/p3Ezc9ger28LrKb5uQz6QSdHe9aky3osshxXUsIBrZI6wjShWZbp44VWSSNLtVOTLd0o4sCdv7pU9vF6LCmWER5hhPUF0Xo+p9qTgQUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/set4.png
// module id = stnF
// module chunks = 1